import { useEffect, useState } from "react";

/** Is the element sitting over a dark background right now? Samples what's painted under it (page sections, dialogs) on scroll/resize. */
export function useOnDark(ref, enabled = true, flipAtNight = false) {
  const [dark, setDark] = useState(false);
  useEffect(() => {
    if (!enabled) { setDark(false); return undefined; }
    let raf = 0;
    const lum = (el) => {
      const m = getComputedStyle(el).backgroundColor.match(/rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?\)/);
      if (!m || (m[4] !== undefined && parseFloat(m[4]) < 0.5)) return null;
      return (0.2126 * m[1] + 0.7152 * m[2] + 0.0722 * m[3]) / 255;
    };
    const check = () => {
      raf = 0;
      const el = ref.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      if (!r.width) return;
      const y = r.top + r.height / 2;
      let hits = 0;
      for (const x of [r.left + 10, r.left + r.width / 2, r.right - 10]) {
        const stack = document.elementsFromPoint(x, y).filter((n) => !el.contains(n) && !n.closest(".portal-cluster,.portal-bar,[data-testid='section-dock'],[data-testid='footer-row']"));
        for (const n of stack) { const l = lum(n); if (l === null) continue; if (l < 0.45) hits += 1; break; }
      }
      // Night mode paints the page as a negative: for elements whose default look is light, the rule flips.
      const night = flipAtNight && document.documentElement.classList.contains("night");
      setDark(night ? hits < 2 : hits >= 2);
    };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(check); };
    check();
    window.addEventListener("scroll", schedule, { passive: true, capture: true });
    window.addEventListener("resize", schedule);
    const iv = setInterval(check, 700);
    return () => { window.removeEventListener("scroll", schedule, { capture: true }); window.removeEventListener("resize", schedule); clearInterval(iv); if (raf) cancelAnimationFrame(raf); };
  }, [ref, enabled, flipAtNight]);
  return dark;
}
